export default "__VITE_ASSET__wpdnPf_W__"